<template>
  <v-snackbar
    v-model="isNewVictim"
    :timeout="snackTimer"
    top
    color="primary"
    transition="slide-x-reverse-transition"
  >
    <v-icon>
      mdi-check-circle
    </v-icon>

    {{ $t("events.newVictim") }}

    <template v-slot:action="{ attrs }">
      <v-btn
        icon
        color="white"
        v-bind="attrs"
        @click="isNewVictim = false"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>

  </v-snackbar>
</template>

<script>

export default {
  name: 'VictimNotification',

  data: () => ({
    snackTimer : 2000,
  }),

  computed: {
    isNewVictim: {
      get () {
        return this.$store.getters['notification/isNewVictim'];
      },
      set (value) {
        this.$store.commit('notification/SET_IS_NEW_VICTIM', value)
      }
    }
  },

};
</script>
